import { Plan } from './plan.model';
import { dateFormatter, dayReadable, FORMAT_DATE } from '../utils/dateFormatter';

export class Day {

  constructor(id, date, comment,plans = []) {
    this._id = id;
    this._date = date;
    this._comment = comment;
    this._plans = plans;
  }

  name() {
    return dateFormatter(this.date, FORMAT_DATE) + ' ' + dayReadable(this.date);
  }

  get id() {
    return this._id;
  }

  get date() {
    return this._date;
  }

  set date(date) {
    this._date = date;
  }

  get comment() {
    return this._comment;
  }

  set comment(comment) {
    this._comment = comment;
  }

  get plans() {
    return this._plans;
  }

  getPlan(id) {
    return this._plans.find(p => p.id === id);
  }

  getPlanBy(id, field = 'name') {
    return this._plans.find(p => p[field] === id);
  }

  hasPlan(id, field) {
    return this.getPlanBy(id, field) !== undefined;
  }

  getNextPlan(planId) {
    const index = this._plans.findIndex(p => p.id === planId);
    const next = this._plans[index + 1];

    if (!next)
      return null;

    return next;
  }

  getPrevPlan(planId) {
    const index = this._plans.findIndex(p => p.id === planId);
    const prev = this._plans[index - 1];

    if (!prev)
      return null;

    return prev;
  }

  addPlan(plan) {
    if (!(plan instanceof Plan))
      throw new Error('Unsupported type');

    const index = this._plans.findIndex(p => plan.time < p.time);

    index === -1 ? this._plans.push(plan) : this._plans.splice(index, 0, plan);
  }

  removePlan(id) {
    this._plans = this._plans.filter(p => p.id !== id);
  }

  hasComment() {
    return this._comment.length > 0;
  }

  isEmpty() {
    return this._plans.length === 0;
  }

  getNumberOfPlans() {
    return this._plans.length;
  }

  toJSON() {
    return {
      id: this.id,
      date: this.date,
      comment: this.comment,
      plans: this.plans,
    };
  }
}
